// extracted by mini-css-extract-plugin
export default {"form":"UploadInput_form__RFNmB","root":"UploadInput_root__1iWmq","fileImg":"UploadInput_fileImg__C56bf"};